module.exports = __webpack_public_path__ + "img/17-2.12f1a1c3.jpg";